import React from 'react'
import WizardStepBase from '../base'
import { Link, withRouter } from 'react-router-dom'

import OptionSelectBox from 'app/components/option_select_box'
import OptionSelectFiler from 'app/components/option_select_filter'
import constants from '../../../constants'
import _ from 'lodash'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as orderActions from '../../../actions/order_actions';

class WizardStepFour extends WizardStepBase{
  constructor(props) {
    super(props);
    this.stepNum = 4;
    this.state = {
      filter: null,
      showColorHelp: true
    }
  }

  getSelectedGroupItem(group) {
    return this.props.order_state.groups[group];
  }

  validateMandatoryAttributes(attributes) {
    const attrs = ['lock', 'lock_pad']
  }

  setColorFilter(id, event) {
    event.preventDefault();
    this.setState({
      filter: id,
      showColorHelp: false
    });
  }

  renderColorFilter() {
    return this.props.parts_state.colors.map((item, index) => {
      return (
        <div key={index}
             className={`round-checkbox-item ${this.state.filter == item.id ? 'active' : ''}`}
             onClick={this.setColorFilter.bind(this, item.id)}
        >
          <label>
            <img className='round-checkbox-icon' src={item.image.url} />
            <div className='label-'>{item.title}</div>
          </label>
        </div>
      );
    });
  }

  get isStepValid() {
    const
      construction = this.props.constructions_state.selected_type,

      options = _.get(construction, 'construction_type_options');
    if (!options) { return true; }

    return true;
  }

  render() {
    let
      parts = this.props.parts_state,
      openCurrent = null,
      chain = this.props.order_state.actionsChain,
      isFactoryStandard = this.props.order_state.groups.size.selected == 'CUSTOM_SIZE';

    if (chain && chain.length) {
      openCurrent = chain[0].split('-')[1];
    }

    return (
      <div>
        <h1>
          Замки и фурнитура
          <div className='round-checkbox-group'>
            { this.renderColorFilter() }
            <span className={`help- ${this.state.showColorHelp ? 'active' : ''}`}>Выберите цвет фурнитуры</span>
          </div>
        </h1>
        <div className='wizard-screen screen-3'>
          <div className='wizard-screen-row small-margin-'>
            { isMobile ?
              <div className='wizard-screen-cell cell-1-2'>
                {(() => !this.props.parts_state.colors ? (<div />) : (
                  <OptionSelectFiler
                    title="Цвет фурнитуры"
                    buttonTitle="Выбрать цвет"
                    buttonShortTitle="Выбрать цвет"
                    onItemSelected={this.setColorFilter.bind(this)}
                    currentGroupItem={this.state.filter}
                    collection={ this.props.parts_state.colors }
                  />
                ))()}
              </div> : null
            }
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.LockCommon.length ? (<div />) : (
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'LockCommon' }
                  title="Основной замок"
                  buttonTitle="Выбрать основной замок"
                  buttonShortTitle="Выбрать замок"
                  group='LockCommon'
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  currentGroupItem={this.getSelectedGroupItem('LockCommon')}
                  collection={ isFactoryStandard ? parts.LockCommon : parts.LockCommonFactory }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.LockAdditional.length ? (<div />) : (
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'LockAdditional' }
                  title="Дополнительный замок"
                  buttonTitle="Выбрать дополнительный замок"
                  buttonShortTitle="Выбрать замок"
                  group="LockAdditional"
                  currentGroupItem={this.getSelectedGroupItem('LockAdditional')}
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  collection={ isFactoryStandard ? parts.LockAdditional : parts.LockAdditionalFactory }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
          </div>
          <div className='wizard-screen-row small-margin-'>
            {(() => !parts.LockPadCommon.length ? (<div />) : (
              <div className='wizard-screen-cell cell-1-2'>
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'LockPadCommon' }
                  title="Накладка на основной замок"
                  buttonTitle="Выбрать накладку"
                  buttonShortTitle="Выбрать накладку"
                  group="LockPadCommon"
                  currentGroupItem={this.getSelectedGroupItem('LockPadCommon')}
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  collection={ this.state.filter ? parts.LockPadCommon.filter(item => item.part_color_id == this.state.filter) : parts.LockPadCommon }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              </div>
            ))()}
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.LockPadAdditional.length ? (<div />) : (
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'LockPadAdditional' }
                  title="Накладка на доп замок"
                  buttonTitle="Выбрать накладку"
                  buttonShortTitle="Выбрать накладку"
                  group="LockPadAdditional"
                  currentGroupItem={this.getSelectedGroupItem('LockPadAdditional')}
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  collection={ this.state.filter ? parts.LockPadAdditional.filter(item => item.part_color_id == this.state.filter) : parts.LockPadAdditional }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
          </div>
          <div className='wizard-screen-row'>
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.DoorKnob.length ? (<div />) : (
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'DoorKnob' }
                  title="Ручка"
                  buttonTitle="Выбрать ручку"
                  buttonShortTitle="Выбрать ручку"
                  group="DoorKnob"
                  currentGroupItem={this.getSelectedGroupItem('DoorKnob')}
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  collection={ this.state.filter ? parts.DoorKnob.filter(item => item.part_color_id == this.state.filter) : parts.DoorKnob }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.Latch.length ? (<div />) : (
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'Latch' }
                  title="Задвижка"
                  buttonTitle="Выбрать задвижку"
                  buttonShortTitle="Выбрать задвижку"
                  group="Latch"
                  currentGroupItem={this.getSelectedGroupItem('Latch')}
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  collection={ this.state.filter ? parts.Latch.filter(item => item.part_color_id == this.state.filter) : parts.Latch }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
          </div>
        </div>
        <div className="mobile-show">
          <Link onClick={this.stepChange} className='back-link' to={constants.ROUTES.STEP3}>Вернуться к внешнему виду</Link>
        </div>
        <Link onClick={this.stepChange} className='button button-red button-large wizard-next-action-button' to={constants.ROUTES.STEP5}>
          <span>перейти к выбору дополнительных опций</span>
        </Link>
        <div className="mobile-hidden">
          <Link className='back-link' to={constants.ROUTES.STEP3}>Вернуться к внешнему виду</Link>
        </div>
        {this.renderConfirm()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    parts_state: state.partsState,
    constructions_state: state.constructionsState,
    order_state: state.orderState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch, null, {pure: false})(WizardStepFour));



// WEBPACK FOOTER //
// ./app/javascript/app/pages/wizard_steps/step_4/index.jsx